import script from "./PageDiagnostic.vue?vue&type=script&setup=true&lang=js"
export * from "./PageDiagnostic.vue?vue&type=script&setup=true&lang=js"

import "./PageDiagnostic.vue?vue&type=style&index=0&id=5d2af602&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d2af602"]])

export default __exports__